import { environment } from 'src/environments/environment';
const isProd = environment.production;

export const ConstantsService = {
  api: {
    // frontEnd: isProd
    //   ? 'https://p67logistics.izisoft.io/v1'
    //   : 'https://p67logisticstest.izisoft.io/v1',
    frontEnd: 'https://p67logistics.izisoft.io/v1',
    // frontEnd: 'http://192.168.11.26:4067/v1',
    // frontEnd: 'http://127.0.0.1:4067/v1',
  },
};
